import React, { Fragment, useContext, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import EditMyProfile from "./EditmyProfile";
import MyProfileEdit from "./MyProfileEdit";
// import UserTable from './UserTable';
import Workexperience from "./Workexperience";
import Mainskills from "./Mainskills";
import Worksample from "./Worksample";
import ResumeSkills from "./ResumeSkills";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { showToast } from "../../Common/Toast";
import Spinner from "../../Common/Spinner";
import { LOADER_TIMEOUT } from "../../../Constant";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { useParams } from "react-router";
import Educationbackground from "./Educationbackground";
import CandidateStatus from "./CandidateStatus";
import { extractAfterLastHyphen } from "../../Common/CommonFunction";
import FetchCandidateAppliedJobs from "./FetchCandidateAppliedJobs";
import { fetchCandidateAppliedJobsRequest } from "../../../redux/recruiter/fetch_candidate_applied_jobs/actions";
const ProfileEditContain = () => {
  const { cand_id, jobcad_id } = useParams();

  const dispatch = useDispatch();
  const { showPreloader } = useContext(PreloaderContext);

  useEffect(() => {
    dispatch(
      fetchJobseekerDataRequest({
        seeker_id: extractAfterLastHyphen(cand_id),
        job_cand_id: extractAfterLastHyphen(jobcad_id),
      })
    );
  }, []);

  const fetchJobseekerDataReducerData = useSelector(
    (state) => state.fetchJobseekerDataReducer
  );
  let profileData = [];
  if (
    !fetchJobseekerDataReducerData.isLoading &&
    fetchJobseekerDataReducerData.data.data
  ) {
    profileData = fetchJobseekerDataReducerData.data.data;
  }
  console.log("rd", fetchJobseekerDataReducerData);
  console.log("pd", profileData);

  useEffect(() => {
    if (
      fetchJobseekerDataReducerData.status &&
      fetchJobseekerDataReducerData.message != ""
    ) {
      showToast("success", fetchJobseekerDataReducerData.message);
      // dispatch(resetJob());
    } else if (
      fetchJobseekerDataReducerData.status == false &&
      fetchJobseekerDataReducerData.message != ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", fetchJobseekerDataReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", fetchJobseekerDataReducerData.message);
      }
      // dispatch(resetJob());
    }
  }, [fetchJobseekerDataReducerData]);

  const { data, loading, error } = useSelector((state) => state.fetchCandidateAppliedJobsReducer) || {};
  const jobs = Array.isArray(data) ? data : []; // Ensure `data` is always an array

  useEffect(() => {
    if (cand_id) {
      dispatch(fetchCandidateAppliedJobsRequest({ seeker_id: extractAfterLastHyphen(cand_id) }));
    }
  }, [dispatch, cand_id]);

  return (
    <div>
      {fetchJobseekerDataReducerData.isLoading ? (
        <Spinner /> // Show loader when isLoading is true
      ) : (
        // <Row>
        //   <Col xs="12" sm="12" md="12" lg="12" xl="5">
        //     <MyProfileEdit profileData={profileData} />
        //     <ResumeSkills profileData={profileData} />
        //     <Educationbackground profileData={profileData} />
        //   </Col>
        //   <Col xl="7">

        //     {/* {jobcad_id ? ( // Check if jobcad_id is present
        //       <CandidateStatus profileData={profileData} />
        //     ) : jobs.length > 0 && (
        //       <FetchCandidateAppliedJobs jobs={jobs} />
        //     )} */}

        //     {(profileData?.candidate_status?.length) > 0 && ( // Check if jobcad_id is present
        //       <CandidateStatus profileData={profileData}  />
        //     )}

        //     <EditMyProfile profileData={profileData} />
        //     <Mainskills profileData={profileData} />
        //   </Col>

        //   <Col xl="12">
        //     <Workexperience profileData={profileData} />
        //   </Col>

        //   <Col xl="12">
        //     <Worksample profileData={profileData} />
        //   </Col>
        // </Row>

        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="5">
            <MyProfileEdit profileData={profileData} />
            <ResumeSkills profileData={profileData} />

            {/* Only show Education background here if candidate_status exists */}
            {profileData?.candidate_status?.length > 0 && (
              <Educationbackground profileData={profileData} />
            )}
          </Col>

          <Col xl="7">
            {profileData?.candidate_status?.length > 0 && (
              <CandidateStatus profileData={profileData} />
            )}

            <EditMyProfile profileData={profileData} />
            <Mainskills profileData={profileData} />
          </Col>

          {/* If candidate_status is empty → show Education background full width */}
          {(!profileData?.candidate_status ||
            profileData?.candidate_status?.length === 0) && (
            <Col xl="12">
              <Educationbackground profileData={profileData} />
            </Col>
          )}

          <Col xl="12">
            <Workexperience profileData={profileData} />
          </Col>

          <Col xl="12">
            <Worksample profileData={profileData} />
          </Col>
        </Row>



//         <Row>
//   {/* Left column with MyProfileEdit + ResumeSkills */}
//   <Col xs="12" sm="12" md="12" lg="12" xl="5">
//     <MyProfileEdit profileData={profileData} />
//     <ResumeSkills profileData={profileData} />

//     {/* Educationbackground stays here if CandidateStatus exists */}
//     {profileData?.candidate_status?.length > 0 && (
//       <Educationbackground profileData={profileData} />
//     )}
//   </Col>

//   {/* Right column with CandidateStatus + EditMyProfile + Mainskills */}
//   {profileData?.candidate_status?.length > 0 && (
//     <Col xl="7">
//       <CandidateStatus profileData={profileData} />
//       <EditMyProfile profileData={profileData} />
//       <Mainskills profileData={profileData} />
//     </Col>
//   )}

//   {/* If CandidateStatus is empty → show Educationbackground full width */}
//   {profileData?.candidate_status?.length === 0 && (
//     <Col xl="12">
//       <Educationbackground profileData={profileData} />
//     </Col>
//   )}

//   <Col xl="12">
//     <Workexperience profileData={profileData} />
//   </Col>

//   <Col xl="12">
//     <Worksample profileData={profileData} />
//   </Col>
// </Row>

      )}
    </div>
  );
};
export default ProfileEditContain;
